import { useSelector } from 'react-redux';
import { Col, Card, CardHeader, CardBody, Table } from 'reactstrap';
import { H4 } from '../../../../AbstractElements';
import DualListBoxFAQ from 'Component/Learning/Common/DualListBoxFAQ';

const FAQProgramContain = () => {
    const detail = useSelector(state => state.MainProgram.detail)

    return (
        <Card>
            <CardHeader className="pb-0">
                <H4 attrH4={{ className: 'card-title mb-0 text-center' }}>{detail.faq && detail.faq.length > 0 ? 'Daftar FAQ' : 'Belum ada FAQ terdaftar'}</H4>
            </CardHeader>
            <CardBody>
                {detail.faq && detail.faq.length > 0 && (
                    <Col sm="12 order-2">
                        <Card>
                            <div className="table-responsive">
                                <Table>
                                    <thead className="table-light">
                                        <tr>
                                            <th scope="col"><DualListBoxFAQ datas={detail.faq} /></th>
                                            <th scope="col">Pertanyaan</th>
                                            <th scope="col">Jawaban</th>
                                            <th scope="col">Terlihat</th>
                                            {/* <th scope="col" className="text-center">Aksi</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            detail.faq && detail.faq.map((faq, index) =>
                                                <tr key={`faq-${index}`}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td>{faq.question}</td>
                                                    <td>{faq.answer}</td>
                                                    <td>{faq.is_show ? 'Ya' : 'Tidak'}</td>
                                                    {/* <td>
                                    <div className="d-flex justify-content-center">
                                        <Link to={`${process.env.PUBLIC_URL}/faq/faq-users/${faq.id}`} title="Users Faq" className="p-1"
                                        target="_blank"
                                        >
                                            <i className="icofont icofont-users-social fa-lg"></i>
                                        </Link>
                                        <Link to={`${process.env.PUBLIC_URL}/faq/faq-detail/${faq.id}`} title="Detail Faq" className="p-1" 
                                        target="_blank"
                                        >
                                            <i className="fa fa-info-circle mx-auto fa-lg"></i>
                                        </Link>
                                        <Link to={`${process.env.PUBLIC_URL}/faq/faq-add/${faq.id}`} title="Edit Faq" className="p-1" 
                                        target="_blank"
                                        >
                                            <i className="fa fa-edit mx-auto text-secondary fa-lg"></i>
                                        </Link>
                                        <Btn
                                            attrBtn={{
                                                color: 'link',
                                                outline: true,
                                                className: 'p-1',
                                                onFocus: () => {
                                                    // dispatch(setField({ ...dataAttachDetach, 'id': 9, 'type': 'detach', 'faq_id': {value:faq.id} }))
                                                    dispatch(setField({ field: 'type', value: 'detach' }));
                                                    const faqId = [{value:faq.id}];
                                                    dispatch(setField({ field: 'faq_id', value: faqId }));
                                                },
                                                onClick: () => {
                                                    handleDetach()
                                                }
                                            }}
                                        >
                                            <i className="fa fa-trash-o mx-auto text-danger fa-lg"></i>
                                        </Btn>
                                    </div >
                                </td> */}
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </Card>
                    </Col>
                )}
            </CardBody>
        </Card>
    );
};
export default FAQProgramContain;